const VERSION = '2.0.7b'
export default VERSION
